import { render } from "./contactIndex.vue?vue&type=template&id=434e2847"
import script from "./contactIndex.vue?vue&type=script&lang=js"
export * from "./contactIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__